import type { SVGIconsProps } from "../type";

export function CommunityIcon({ className, ...restProps }: SVGIconsProps) {
  return (
    <svg
      width="87"
      height="60"
      className={className}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g clipPath="url(#clip0_15625_295393)">
        <path
          d="M23.3693 50.4922C23.1083 50.4922 22.8473 50.4922 22.5537 50.4922C20.4983 50.4922 18.7365 50.8184 17.3337 51.2099C16.1265 51.5362 14.7563 52.0908 13.6144 53.0043C12.4399 53.9178 11.3959 55.2554 11.1675 57.1151C11.0697 57.9959 11.1023 59.8556 11.1349 60.8996C11.1675 62.7918 12.7009 64.2273 14.5605 64.2273H22.2274C21.7707 63.2486 21.5097 62.1719 21.477 61.0301C21.4444 59.9208 21.3465 56.8867 21.5749 55.2881C21.6728 54.4398 21.9012 53.6568 22.1622 52.9391C22.4884 52.0256 22.9125 51.2099 23.4019 50.4922H23.3693Z"
          fill="white"
          strokeWidth="4.07812"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.4883 64.2273H76.1552C78.0148 64.2273 79.5482 62.7592 79.5808 60.8996C79.5808 59.8556 79.6461 57.9959 79.5482 57.1151C79.3524 55.2554 78.2758 53.9178 77.1013 53.0043C75.9594 52.1234 74.5892 51.5688 73.3821 51.2099C71.9792 50.8184 70.2174 50.4922 68.1621 50.4922C67.9011 50.4922 67.6074 50.4922 67.3464 50.4922C67.8358 51.2099 68.2599 52.0256 68.5862 52.9391C68.8472 53.6568 69.0429 54.4398 69.1734 55.2881C69.4018 56.8867 69.3039 59.9208 69.2713 61.0301C69.2387 62.1719 68.9777 63.2486 68.5209 64.2273H68.4883Z"
          fill="white"
          strokeWidth="4.07812"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.4196 49.4507C38.5728 48.8308 41.6722 48.2109 45.3588 48.2109C49.0454 48.2109 52.1448 48.8308 54.2981 49.4507C55.4073 49.7769 56.7449 50.2337 57.9194 50.9514C59.1266 51.7018 60.3337 52.8111 60.9209 54.4749C61.0841 54.8991 61.1819 55.3884 61.2798 55.8778C61.4429 57.0197 61.3777 59.5644 61.3451 60.8694C61.2798 62.7291 59.7464 64.1972 57.9194 64.1972H32.7982C30.9712 64.1972 29.4378 62.7617 29.3726 60.8694C29.3399 59.5644 29.2747 57.0197 29.4378 55.8778C29.5031 55.3558 29.6336 54.8991 29.7967 54.4749C30.3839 52.8111 31.5911 51.7018 32.7982 50.9514C33.9727 50.2337 35.3103 49.7769 36.4196 49.4507Z"
          fill="white"
          strokeWidth="4.07812"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.3091 35.7106C61.3091 31.9261 64.3758 28.8594 68.193 28.8594C72.0101 28.8594 75.0768 31.9261 75.0768 35.7106C75.0768 39.4951 72.0101 42.5945 68.193 42.5945C64.3758 42.5945 61.3091 39.4951 61.3091 35.7106Z"
          fill="white"
          strokeWidth="4.07812"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.1924 31.1442C36.1924 26.0873 40.3031 21.9766 45.36 21.9766C50.4169 21.9766 54.5276 26.0873 54.5276 31.1442C54.5276 36.2011 50.4169 40.2792 45.36 40.2792C40.3031 40.2792 36.1924 36.2011 36.1924 31.1442Z"
          fill="white"
          strokeWidth="4.07812"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6689 35.7106C15.6689 31.9261 18.7357 28.8594 22.5528 28.8594C26.3699 28.8594 29.4367 31.9261 29.4367 35.7106C29.4367 39.4951 26.3699 42.5945 22.5528 42.5945C18.7357 42.5945 15.6689 39.4951 15.6689 35.7106Z"
          fill="white"
          strokeWidth="4.07812"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
